import React from 'react';
import { useLoading } from '../context/LoadingContext';
import LoadingOverlay from './LoadingOverlay';
import MessageLog from './MessageLog';

/**
 * Composant qui gère l'affichage global du loading et des messages
 * À placer une seule fois dans l'App ou dans Layout
 */
const LoadingSystem = () => {
  const { messageLogType, messageLogText, messageLogKey } = useLoading();

  return (
    <>
      {/* Overlay de chargement */}
      <LoadingOverlay />
      
      {/* Messages via le composant MessageLog existant */}
      {messageLogText && (
        <MessageLog
          key={messageLogKey} // Force la re-création pour déclencher les animations
          type={messageLogType}
          text={messageLogText}
          autoHide={false} // Géré par le contexte
        />
      )}
    </>
  );
};

export default LoadingSystem;
